import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#1A202C] text-gray-400 py-12 border-t border-gray-800" data-id="element-53">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
          <div className="text-center space-y-4" data-id="element-55">
            <p className="text-lg" data-id="element-56">
              © 2024 Programa Desinflámate 65+. Todos los derechos reservados.
            </p>
            <p className="text-sm text-gray-500" data-id="element-57">
              Este producto no sustituye el consejo médico profesional.
            </p>

            <div className="flex justify-center gap-6 pt-4" data-id="element-58">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-[#E07856] transition-colors underline text-base focus:outline-none focus:ring-2 focus:ring-[#E07856] rounded px-2 py-1" data-id="element-59">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-60">|</span>
              <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-[#E07856] transition-colors underline text-base focus:outline-none focus:ring-2 focus:ring-[#E07856] rounded px-2 py-1" data-id="element-61">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-62">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-63">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          type: 'spring',
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-64">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-65">
                <h2 className="text-2xl font-bold text-[#2D3748]" data-id="element-66">
                  Política de Privacidad
                </h2>
                <button onClick={() => setShowPrivacy(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#E07856]" data-id="element-67">
                  <X className="w-6 h-6 text-gray-600" data-id="element-68" />
                </button>
              </div>

              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-700 space-y-4" data-id="element-69">
                <p className="text-sm text-gray-500" data-id="element-70">
                  Última actualización: Enero 2024
                </p>

                <section data-id="element-71">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-72">
                    1. Información que Recopilamos
                  </h3>
                  <p className="leading-relaxed" data-id="element-73">
                    Recopilamos información personal que usted nos proporciona
                    directamente al adquirir nuestro programa "14 Días
                    Desinflámate a los 65+", incluyendo nombre, correo
                    electrónico y datos de pago necesarios para procesar su
                    compra.
                  </p>
                </section>

                <section data-id="element-74">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-75">
                    2. Uso de la Información
                  </h3>
                  <p className="leading-relaxed mb-2" data-id="element-76">
                    Utilizamos su información personal para:
                  </p>
                  <ul className="list-disc pl-6 space-y-2" data-id="element-77">
                    <li data-id="element-78">Procesar y completar su compra del programa</li>
                    <li data-id="element-79">Enviarle el material digital del programa</li>
                    <li data-id="element-80">Comunicarnos con usted sobre su compra</li>
                    <li data-id="element-81">Mejorar nuestros servicios y contenido</li>
                  </ul>
                </section>

                <section data-id="element-82">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-83">
                    3. Protección de Datos
                  </h3>
                  <p className="leading-relaxed" data-id="element-84">
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger su información personal contra acceso no
                    autorizado, pérdida o alteración. Todos los pagos se
                    procesan a través de plataformas seguras certificadas.
                  </p>
                </section>

                <section data-id="element-85">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-86">
                    4. Compartir Información
                  </h3>
                  <p className="leading-relaxed" data-id="element-87">
                    No vendemos, alquilamos ni compartimos su información
                    personal con terceros para fines de marketing. Solo
                    compartimos información con proveedores de servicios
                    necesarios para procesar pagos y entregar el producto
                    digital.
                  </p>
                </section>

                <section data-id="element-88">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-89">
                    5. Sus Derechos
                  </h3>
                  <p className="leading-relaxed mb-2" data-id="element-90">Usted tiene derecho a:</p>
                  <ul className="list-disc pl-6 space-y-2" data-id="element-91">
                    <li data-id="element-92">Acceder a su información personal</li>
                    <li data-id="element-93">Solicitar corrección de datos inexactos</li>
                    <li data-id="element-94">Solicitar la eliminación de sus datos</li>
                    <li data-id="element-95">Retirar su consentimiento en cualquier momento</li>
                  </ul>
                </section>

                <section data-id="element-96">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-97">
                    6. Cookies
                  </h3>
                  <p className="leading-relaxed" data-id="element-98">
                    Utilizamos cookies esenciales para el funcionamiento del
                    sitio web y para mejorar su experiencia de usuario. Puede
                    configurar su navegador para rechazar cookies, aunque esto
                    puede afectar la funcionalidad del sitio.
                  </p>
                </section>

                <section data-id="element-99">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-100">
                    7. Contacto
                  </h3>
                  <p className="leading-relaxed" data-id="element-101">
                    Si tiene preguntas sobre esta Política de Privacidad o desea
                    ejercer sus derechos, puede contactarnos a través del correo
                    electrónico proporcionado en su compra.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Terms and Conditions Modal */}
      <AnimatePresence data-id="element-102">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-103">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          type: 'spring',
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-104">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-105">
                <h2 className="text-2xl font-bold text-[#2D3748]" data-id="element-106">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTerms(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#E07856]" data-id="element-107">
                  <X className="w-6 h-6 text-gray-600" data-id="element-108" />
                </button>
              </div>

              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-700 space-y-4" data-id="element-109">
                <p className="text-sm text-gray-500" data-id="element-110">
                  Última actualización: Enero 2024
                </p>

                <section data-id="element-111">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-112">
                    1. Aceptación de Términos
                  </h3>
                  <p className="leading-relaxed" data-id="element-113">
                    Al adquirir el programa "14 Días Desinflámate a los 65+",
                    usted acepta estos Términos y Condiciones en su totalidad.
                    Si no está de acuerdo con alguna parte de estos términos, no
                    debe realizar la compra.
                  </p>
                </section>

                <section data-id="element-114">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-115">
                    2. Descripción del Producto
                  </h3>
                  <p className="leading-relaxed" data-id="element-116">
                    El programa "14 Días Desinflámate a los 65+" es un producto
                    digital que incluye guías, planes de comidas, rutinas de
                    ejercicio suave y protocolos de bienestar. Es un material
                    educativo y de orientación general, no un tratamiento
                    médico.
                  </p>
                </section>

                <section data-id="element-117">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-118">
                    3. Descargo de Responsabilidad Médica
                  </h3>
                  <p className="leading-relaxed mb-2" data-id="element-119">
                    <strong className="text-[#E07856]" data-id="element-120">IMPORTANTE:</strong> Este
                    programa NO sustituye el consejo, diagnóstico o tratamiento
                    médico profesional. Antes de comenzar cualquier programa de
                    alimentación o ejercicio:
                  </p>
                  <ul className="list-disc pl-6 space-y-2" data-id="element-121">
                    <li data-id="element-122">
                      Consulte con su médico, especialmente si tiene condiciones
                      de salud preexistentes
                    </li>
                    <li data-id="element-123">
                      No suspenda ningún medicamento sin consultar a su médico
                    </li>
                    <li data-id="element-124">
                      Si experimenta dolor o malestar, detenga el programa y
                      consulte a un profesional
                    </li>
                  </ul>
                </section>

                <section data-id="element-125">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-126">
                    4. Resultados
                  </h3>
                  <p className="leading-relaxed" data-id="element-127">
                    Los resultados individuales pueden variar. No garantizamos
                    resultados específicos de pérdida de peso o mejora de salud.
                    Los testimonios y ejemplos mostrados no son garantía de
                    resultados similares para todos los usuarios.
                  </p>
                </section>

                <section data-id="element-128">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-129">
                    5. Propiedad Intelectual
                  </h3>
                  <p className="leading-relaxed" data-id="element-130">
                    Todo el contenido del programa, incluyendo textos, imágenes,
                    diseños y materiales, está protegido por derechos de autor.
                    Usted recibe una licencia personal, no transferible, para
                    uso individual. No está permitido compartir, reproducir o
                    distribuir el material.
                  </p>
                </section>

                <section data-id="element-131">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-132">
                    6. Política de Reembolso
                  </h3>
                  <p className="leading-relaxed" data-id="element-133">
                    Debido a la naturaleza digital del producto y el acceso
                    inmediato al contenido completo, todas las ventas son
                    finales. No se ofrecen reembolsos una vez que el material ha
                    sido descargado o accedido.
                  </p>
                </section>

                <section data-id="element-134">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-135">
                    7. Acceso al Producto
                  </h3>
                  <p className="leading-relaxed" data-id="element-136">
                    Tras la compra, recibirá acceso inmediato al material
                    digital. Es su responsabilidad descargar y guardar el
                    contenido. No garantizamos acceso indefinido a través de
                    nuestra plataforma.
                  </p>
                </section>

                <section data-id="element-137">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-138">
                    8. Limitación de Responsabilidad
                  </h3>
                  <p className="leading-relaxed" data-id="element-139">
                    No nos hacemos responsables de ningún daño directo,
                    indirecto, incidental o consecuente que resulte del uso o la
                    imposibilidad de usar este programa. El uso del programa es
                    bajo su propio riesgo.
                  </p>
                </section>

                <section data-id="element-140">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-141">
                    9. Modificaciones
                  </h3>
                  <p className="leading-relaxed" data-id="element-142">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios entrarán en vigor
                    inmediatamente después de su publicación. Es su
                    responsabilidad revisar periódicamente estos términos.
                  </p>
                </section>

                <section data-id="element-143">
                  <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-144">
                    10. Ley Aplicable
                  </h3>
                  <p className="leading-relaxed" data-id="element-145">
                    Estos términos se rigen por las leyes aplicables en Estados
                    Unidos. Cualquier disputa se resolverá en los tribunales
                    competentes de la jurisdicción correspondiente.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}